module.exports = __webpack_public_path__ + "static/media/YF88_3.8679f5e9.jpg";